module.exports = __webpack_public_path__ + "static/media/Portrait-10216.9b4464e9.jpg";